import { GridColDef } from "@mui/x-data-grid-pro";
import {
  DownloadIcon,
  GKDataGrid,
  Grid2,
  SendIcon,
  Typography,
} from "components";
import dayjs from "dayjs";
import useGenerateQueryParams from "hooks/useGenerateQueryParams";
import { useFetchQuery } from "hooks/useQueries";
import DashboardLayout from "layouts/DashboardLayout";
import { useNavigate, useParams } from "react-router-dom";
import { moneyCommaSeparatorPoint } from "utils/MathFunction";
import { extraColumnsField } from "utils/helpers";
import useDocumentTitle from "utils/useDocumentTitle";
import OrderByIdPopOverAction from "./OrderByIdPopOverAction";

const EquityBasketOrderManager = () => {
  useDocumentTitle("Order Management");

  const { id } = useParams();

  const navigate = useNavigate();

  const requestBody = useGenerateQueryParams("modelPortfolioOrderManager");

  const { data, isFetching } = useFetchQuery({
    key: ["GET_ALL_MODEL_PROTFOLIO_ORDERS", requestBody],
    route: `/model_portfolio/${id}/order-manager/`,
    requestBody,
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Employee Name", "employeeName", 150, 1),
    },
    {
      ...extraColumnsField("Order Type", "orderType", 400, 1),
    },
    {
      ...extraColumnsField("Model Portfolio", "version", 150, 1),
    },
    {
      ...extraColumnsField("Order Date & Time", "orderDate", 120, 1),
      renderCell: (params) => {
        return (
          <Typography display={"flex"} alignItems={"center"}>
            {dayjs(params?.row?.orderDate).format("DD MMM YYYY")}
            {", "}
            {dayjs(params?.row?.orderDate).format("hh:mm a")}
          </Typography>
        );
      },
    },
    {
      ...extraColumnsField("Portfolios", "numPortfolios", 120, 1),
      align: "right",
      headerAlign: "right",
      valueGetter: (param) => param?.row?.numPortfolios || "-",
      valueFormatter: (params) => moneyCommaSeparatorPoint(params.value),
    },
    {
      ...extraColumnsField("Actions", "action", 150, 0),
      align: "right",
      headerAlign: "right",
      renderCell: (params) => {
        return (
          <Grid2 container justifyContent={"flex-end"} gap={1} display={"flex"}>
            <OrderByIdPopOverAction
              item={params.row}
              icon={<DownloadIcon width={20} height={20} />}
              type={["CSV", "ZIP"]}
            />
            <OrderByIdPopOverAction
              item={params.row}
              icon={<SendIcon width={20} height={20} />}
              type={["TRADE", "ORDER"]}
            />
          </Grid2>
        );
      },
    },
  ];

  return (
    <DashboardLayout title="Order Manager">
      <Grid2 container>
        <Grid2 size={12}>
          <GKDataGrid
            name="modelPortfolioOrderManager"
            columns={columns}
            loading={isFetching}
            rows={data?.data?.data || []}
            totalCount={data?.data?.totalCount || 0}
            tableName="modelPortfolioOrderManager"
            exportFile={{
              path: `/model_portfolio/${id}/order-manager/`,
              exportName: "EquityBasketOrdersList",
            }}
            onRowClick={(params) => {
              navigate(
                `/app/equity-basket/${id}/order-manager/${params?.row?.id}/portfolios`,
                {
                  state: {
                    data: params?.row,
                  },
                },
              );
            }}
          />
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default EquityBasketOrderManager;
